export default __webpack_public_path__ + "images/ae066f7e429e887f7d53b29e33e80243-fall_seasonal_desktop.webp";